import Vue from 'vue'
import VueI18n from 'vue-i18n'
import util from '@/util'
import { getPresenterLanguageFromCdn, getDefaultLanguageFallback } from '@/utils/language'
import { pluralizationRules } from '@/utils/language/pluralizationRules'
import * as Sentry from '@sentry/vue'
import constant from '@/constant'

Vue.use(VueI18n)
const localePresenter = util.getPresenterLocaleDefault()

const messagesData = {
}

const initLanguageFromLocalStorage = () => {
  try {
    let data = window.localStorage.getItem('aha-default-language')
    if (data) {
      data = JSON.parse(data)
      messagesData[localePresenter] = data
    }
  } catch (error) {
    Sentry.captureException(new Error('Init language default from localstorage error'), {
      extra: {
        error,
        localePresenter,
      },
    })
  }
}

initLanguageFromLocalStorage()

const i18nPresenter = new VueI18n({
  locale: localePresenter,
  messages: messagesData,
  fallbackLocale: constant.defaultFallbackLocale,
  pluralizationRules,
})

Vue.prototype.$i18nPresenter = i18nPresenter

const initDefaultLanguage = async () => {
  try {
    const data = await getPresenterLanguageFromCdn(localePresenter)
    if (data) {
      i18nPresenter.setLocaleMessage(localePresenter, data)
    }
    if (constant.defaultFallbackLocale !== localePresenter) {
      const dataEng = await getDefaultLanguageFallback()
      i18nPresenter.setLocaleMessage(constant.defaultFallbackLocale, dataEng)
    }
  } catch {
    // do nothing
  }
}

initDefaultLanguage()

export default i18nPresenter
